import { render } from "./Index.vue?vue&type=template&id=4cb8dbb6&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=4cb8dbb6&scoped=true&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb8dbb6"]])

export default __exports__